export default __webpack_public_path__ + "static/media/Cowboy brown.6a05fd7a.png";